<template>
  <div class="py-3">
    <p :class="{ 'text-danger': invalidFields.includes('datetime') }">
      Date &amp; Time
    </p>
    <div
      class="input-group w-25"
      :class="{ 'cursor-pointer': nodStatus.site_visit !== true }"
      @click="
        () => {
          if (nodStatus.site_visit !== true) {
            showDatetimeSelector = true;
          }
        }
      "
    >
      <span
        class="input-group-text border-dark"
        :class="Helper.inputStatusClass(nodStatus.site_visit)"
      >
        <i class="fa-solid fa-calendar-alt" />
      </span>
      <input
        type="text"
        class="form-control border-dark"
        :class="Helper.inputStatusClass(nodStatus.site_visit)"
        disabled
        style="cursor: pointer"
        :value="Helper.formatDate(datetime, false)"
      />
    </div>
    <div class="dropdown-divider mt-4 mb-3"></div>
    <p>Sections</p>
    <button
      class="btn btn-sm btn-outline-light mb-2"
      @click="addSectionClicked"
      v-if="!nodStatus || !nodStatus.site_visit"
    >
      Add Section
      <i class="fa fa-plus-circle ms-1" aria-hidden="true"></i>
    </button>
    <div class="table-responsive p-2 bg-dark rounded" style="max-width: 500px">
      <table class="table table-dark mb-0">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">From</th>
            <th scope="col">To</th>
            <th scope="col" class="text-end">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!showSectionAdd && !sections.length">
            <td colspan="4" class="text-center text-light">No section added</td>
          </tr>
          <tr v-for="(section, i) in sections" :key="i">
            <th scope="row">{{ i + 1 }}</th>
            <td>{{ section.from }}</td>
            <td>{{ section.to }}</td>
            <td class="text-end">
              <button
                class="btn btn-sm btn-outline-danger"
                @click="deleteSection(section)"
                v-if="!nodStatus || !nodStatus.site_visit"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
          <tr v-if="showSectionAdd">
            <th scope="row"></th>
            <td>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="sectionModel.from"
                placeholder="From"
              />
            </td>
            <td>
              <input
                type="text"
                class="form-control form-control-sm"
                v-model="sectionModel.to"
                placeholder="To"
              />
            </td>
            <td class="text-nowrap">
              <button
                class="btn btn-sm btn-outline-success me-2"
                @click="saveSection"
              >
                <i class="fa fa-save" />
              </button>
              <button
                class="btn btn-sm btn-outline-danger me-2"
                @click="showSectionAdd = false"
              >
                <i class="fa fa-times" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="dropdown-divider mt-4 mb-3"></div>
    <p :class="{ 'text-danger': invalidFields.includes('image') }">
      Image Attachment
    </p>
    <p
      v-if="nodStatus.site_visit && !images.length"
      class="fst-italic bg-light text-dark text-center rounded p-3"
    >
      No image
    </p>
    <div
      class="image-grid clickable position-relative"
      v-for="(img, index) in images"
      :key="`image-${index}`"
      @click="openMediaPreview(Helper.formatMediaUrl(img))"
    >
      <img :src="Helper.formatMediaUrl(img)" />
      <button
        type="button"
        class="btn btn-sm btn-light btn-download-thumb position-absolute bottom-0 end-0 m-1"
        @click.stop="Helper.downloadMedia(Helper.formatMediaUrl(img))"
        aria-label="Download image"
      >
        <i class="fa fa-download" />
      </button>
    </div>
    <div
      class="image-grid clickable position-relative"
      v-for="(img, index) in filePreviews"
      :key="`preview-${index}`"
      @click="openMediaPreview(img)"
    >
      <img :src="img" />
      <button
        type="button"
        class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
        @click.stop="removeStagedImage(index)"
        v-if="!nodStatus || !nodStatus.site_visit"
        aria-label="Remove image"
      >
        <i class="fa fa-times" />
      </button>
      <button
        type="button"
        class="btn btn-sm btn-light btn-download-thumb position-absolute bottom-0 end-0 m-1"
        @click.stop="Helper.downloadMedia(img)"
        aria-label="Download image"
      >
        <i class="fa fa-download" />
      </button>
    </div>
    <div
      class="image-grid image-grid-placeholder"
      v-if="!nodStatus || !nodStatus.site_visit"
    >
      <button class="btn h-100 w-100 fw-bold lh-sm" @click="addImage()">
        <i class="fa-solid fa-plus fa-2x mb-2 d-block" />
        Add Image
      </button>
    </div>
    <div class="dropdown-divider mt-4 mb-3"></div>
    <p :class="{ 'text-danger': invalidFields.includes('description') }">
      Description
    </p>
    <textarea
      class="form-control text-black"
      :class="
        (invalidFields.includes('description') ? 'is-invalid' : 'border-dark',
        Helper.inputStatusClass(nodStatus.site_visit))
      "
      placeholder="Enter description here"
      rows="5"
      v-model="description"
      :disabled="nodStatus.site_visit"
    ></textarea>
    <div class="dropdown-divider mt-4 mb-3"></div>
    <p :class="{ 'text-danger': invalidFields.includes('recommendation') }">
      Recommendation
    </p>
    <textarea
      class="form-control text-black"
      :class="
        (invalidFields.includes('recommendation')
          ? 'is-invalid'
          : 'border-dark',
        Helper.inputStatusClass(nodStatus.site_visit))
      "
      placeholder="Enter recommendation here"
      rows="5"
      v-model="recommendation"
      :disabled="nodStatus.site_visit"
    ></textarea>
    <div class="dropdown-divider mt-4 mb-3"></div>
    <p :class="{ 'text-danger': invalidFields.includes('completionDuration') }">
      Expected Completion Duration
    </p>
    <div class="input-group" style="width: 150px">
      <input
        class="form-control text-black"
        :class="
          (invalidFields.includes('completionDuration')
            ? 'is-invalid'
            : 'border-dark',
          Helper.inputStatusClass(nodStatus.site_visit))
        "
        placeholder="0"
        type="number"
        v-model="completionDuration"
        :disabled="nodStatus.site_visit"
      />
      <span class="input-group-text">days</span>
    </div>
    <div class="dropdown-divider mt-4"></div>
    <div
      class="pt-4 d-flex justify-content-start align-items-center"
      v-if="!nodStatus.site_visit"
    >
      <button class="btn btn-secondary px-3 ms-auto" @click="$router.back()">
        Cancel
      </button>
      <button class="btn btn-success px-3 ms-3" @click="submit()">
        Submit
      </button>
    </div>
    <div
      class="pt-4 d-flex justify-content-start align-items-center"
      v-else-if="
        nodStatus.site_visit === 'pending' && Helper.jkrRoles.includes(userRole)
      "
    >
      <button class="btn btn-danger px-3 ms-auto" @click="jkrAction('reject')">
        Reject
      </button>
      <button class="btn btn-success px-3 ms-3" @click="jkrAction('approve')">
        Approve
      </button>
    </div>
    <datetime-selector
      v-if="showDatetimeSelector"
      :date="datetime"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import DatetimeSelector from "@/components/DatetimeSelector";

export default {
  props: ["componentId", "nodStatus", "nodId", "userRole"],
  components: {
    DatetimeSelector,
  },
  data() {
    return {
      siteVisitId: null,
      showDatetimeSelector: false,
      filePreviews: [],
      fileInputs: [],
      invalidFields: [],
      description: null,
      recommendation: null,
      completionDuration: null,
      images: [],
      datetime: new Date(),
      sections: [],
      sectionModel: {
        from: null,
        to: null,
      },
      showSectionAdd: false,
    };
  },
  methods: {
    async jkrAction(action) {
      const body = {};

      let message = "";

      let note =
        "This action is not reversible.<br />Data cannot be changed after it is submitted.";

      const componentStatus = { ...this.nodStatus };

      const swalOptions = {
        icon: "question",
        title: `<h5 class="text-capitalize">${action} Site Visit?</h5>`,
        html: note,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      };

      if (action == "approve") {
        message = "approved";

        componentStatus.site_visit = true;

        swalOptions.confirmButtonColor = "green";
      } else if (action == "reject") {
        message = "rejected";

        note += "<br />Rejected site visit will be removed from case list.";

        componentStatus.site_visit = "rejected";

        body.isRejected = true;

        swalOptions.confirmButtonColor = "red";
      }

      Swal.fire(swalOptions).then(async (result) => {
        if (result.isConfirmed) {
          this.Helper.toggleLoadingSpinner(false);

          this.$nextTick(async () => {
            body.componentStatus = componentStatus;

            await this.API.put(`nod-cases/${this.nodId}`, body);

            await this.getSiteVisitData(true);

            this.Helper.toggleLoadingSpinner(false);

            this.triggerAlert(
              "success",
              `Site visit ${message}`,
              "componentIsCompleted",
              this.siteVisitId
            );
          });
        }
      });
    },
    deleteSection(section) {
      this.sections = this.sections.filter((sec) => sec != section);
      this.Helper.removeToast("Section removed");
    },
    addSectionClicked() {
      if (!this.nodStatus.site_visit) {
        this.showSectionAdd = !this.showSectionAdd;

        this.sectionModel = {
          from: null,
          to: null,
        };
      }
    },
    async saveSection() {
      this.Helper.toggleLoadingSpinner(true);

      this.sections = (this.sections || []).concat(this.sectionModel);

      this.addSectionClicked();

      this.Helper.toggleLoadingSpinner(false);

      this.Helper.successToast("Section added");
    },
    dateSelected(e) {
      if (e) {
        this.datetime = e;
      }

      this.showDatetimeSelector = false;
    },
    async uploadFileInput() {
      return new Promise(async (resolve, reject) => {
        let fileModels = {
          field: "images",
          files: "",
        };

        const formData = new FormData();

        Object.keys(fileModels).forEach((key) => {
          if (key != "files") {
            formData.append(key, fileModels[key]);
          } else {
            this.fileInputs.forEach((file) => {
              formData.append("files", file, file.name);
            });
          }
        });

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("upload", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve(call.data);
        }
      });
    },
    openMediaPreview(media) {
      this.$emit("open-media-preview", media);
    },
    imageChanged(e) {
      const files = e.target.files;
      if (!files || !files.length) return;

      Object.values(files).forEach((file) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = (readerEvent) => {
          this.fileInputs.push(file);

          this.filePreviews.push(readerEvent.target.result);
        };
      });

      this.Helper.successToast(
        `${files.length} image${files.length > 1 ? "s" : ""} added`
      );
    },
    addImage() {
      const input = document.createElement("input");

      input.type = "file";

      input.multiple = true;

      input.accept = "image/*";

      input.onchange = this.imageChanged;

      input.click();
    },
    removeStagedImage(index) {
      this.filePreviews.splice(index, 1);
      this.fileInputs.splice(index, 1);
      this.Helper.removeToast("Image removed");
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    async submit() {
      this.invalidFields = [];

      Swal.fire({
        icon: "question",
        title: "<h5 class='fw-bold'>Submit site visit data?</h5>",
        html: "<p class='mb-0'>This action is not reversible.<br />Data cannot be changed after it is submitted.</p>",
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: "Confirm",
      }).then(async (result) => {
        if (result.isConfirmed) {
          if (
            ((!this.images || this.images.length == 0) &&
              this.filePreviews.length == 0) ||
            !this.description ||
            !this.datetime ||
            !this.recommendation ||
            !this.completionDuration
          ) {
            if (
              (!this.images || this.images.length == 0) &&
              this.filePreviews.length == 0
            ) {
              this.invalidFields.push("image");
            }

            if (!this.description) {
              this.invalidFields.push("description");
            }

            if (!this.datetime) {
              this.invalidFields.push("datetime");
            }

            if (!this.completionDuration) {
              this.invalidFields.push("completionDuration");
            }

            if (!this.recommendation) {
              this.invalidFields.push("recommendation");
            }

            this.triggerAlert("error", "All fields cannot be empty");
          } else {
            this.Helper.toggleLoadingSpinner(true);

            let url = "nod-site-visits";
            let method = "post";

            if (this.siteVisitId) {
              url += `/${this.siteVisitId}`;
              method = "put";
            }

            const [call, error] = await this.Helper.handlePromise(
              this.API[method](url, {
                nod_case: this.nodId,
                datetime: this.datetime,
                sections: this.sections,
                recommendation: this.recommendation,
                description: this.description,
                completionDuration: this.completionDuration,
              })
            );

            if (error) {
              console.error("site-visit", error);

              this.Helper.toggleLoadingSpinner(false);

              this.triggerAlert(
                "error",
                "Error uploading site visit",
                this.siteVisitId
              );

              return;
            } else {
              this.siteVisitId = call.data.id;

              if (this.fileInputs.length) {
                let fileModels = {
                  ref: "nod-site-visit",
                  refId: call.data.id,
                  field: "images",
                  files: "",
                };

                const formData = new FormData();

                Object.keys(fileModels).forEach((key) => {
                  if (key != "files") {
                    formData.append(key, fileModels[key]);
                  } else {
                    this.fileInputs.forEach((file) => {
                      formData.append("files", file, file.name);
                    });
                  }
                });

                const [uploadCall, uploadError] =
                  await this.Helper.handlePromise(
                    this.API.postForm("upload", formData)
                  );

                if (uploadError) {
                  console.error("upload", error);

                  this.Helper.toggleLoadingSpinner(false);

                  this.triggerAlert(
                    "error",
                    "Error uploading site visit images",
                    this.siteVisitId
                  );

                  return;
                } else {
                  const componentStatus = this.nodStatus;

                  componentStatus.site_visit = "pending";

                  await this.API.put(`nod-cases/${this.nodId}`, {
                    componentStatus: componentStatus,
                  });

                  await this.getSiteVisitData(true);

                  this.Helper.toggleLoadingSpinner(false);

                  this.filePreviews = [];

                  this.fileInputs = [];

                  this.triggerAlert(
                    "success",
                    "Site visit uploaded",
                    "componentIsCompleted",
                    this.siteVisitId
                  );

                  return;
                }
              }
            }
          }
        }
      });
    },
    async getSiteVisitData(isSilent) {
      if (!this.siteVisitId) return;

      if (!isSilent) {
        this.Helper.toggleLoadingSpinner(true);
      }

      let url = `nod-site-visits/${this.siteVisitId}`;

      const [call, error] = await this.Helper.handlePromise(this.API.get(url));

      if (error) {
        console.error(error);
      } else {
        this.images = call.data.images || [];

        this.sections = call.data.sections || [];

        this.recommendation = call.data.recommendation;

        this.description = call.data.description;

        this.datetime = call.data.datetime;

        this.completionDuration = parseInt(call.data.completionDuration || 0);
      }

      if (!isSilent) {
        this.Helper.toggleLoadingSpinner(false);
      }

      return;
    },
  },
  mounted() {
    this.siteVisitId = this.componentId;

    this.getSiteVisitData();
  },
};
</script>